import { useDispatch } from "react-redux";
import { addNode } from "../utils/flowSlice";
import { useState } from "react";
import { TbMessageCirclePlus } from "react-icons/tb";

const AIChat = () => {
  // const viewport = useSelector((store) => store.flow.viewport);
  const dispatch = useDispatch();
  const handleButtonClick = () => {
    dispatch(
      addNode({
        type: "aichatNode",
      })
    );
  };

  // State to track hover for each icon
  const [activeTooltip, setActiveTooltip] = useState(null);

  const handleMouseEnter = (id) => {
    setActiveTooltip(id);
  };

  const handleMouseLeave = () => {
    setActiveTooltip(null);
  };

  return (
    <div
      className="rounded-lg flex justify-center items-center relative hover:cursor-pointer"
      onMouseEnter={() => handleMouseEnter("chat")}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={`w-10 h-10 mt-0.5 mx-0.5 flex items-center justify-center rounded-full transition  text-purple-600 hover:cursor-pointer`}
        onClick={handleButtonClick}
      >
        <TbMessageCirclePlus size={24} />
      </button>
      {activeTooltip === "chat" && (
        <span className="absolute left-full ml-2 whitespace-nowrap bg-gray-700 text-white text-xs rounded py-1 px-2">
          AI Chat
        </span>
      )}
    </div>
  );
};

export default AIChat;
